export default __webpack_public_path__ + "static/media/wizard.7066616d.gif";